module.exports = __webpack_public_path__ + "img/Premium Clover 2.a2f988c6.jpg";